import React, { useEffect, useState } from 'react';
import { userState } from '@/states/selectors/userState';
import { useRecoilValue } from 'recoil';
import Head from 'next/head';

// eslint-disable-next-line consistent-return

/**
 * Google Analytics データ送信コンポーネント
 * 画面表示時にページビューデータをGTMのdataLayerに送信する共通コンポーネント。
 */
export const AnalyticsData = () => {
  const user = useRecoilValue(userState);
  const [analyticsData, setAnalyticsData] = useState('');

  useEffect(() => {
    let hash = '';

    if (user.ispCnNo !== '') {
      // 会員番号をそのまま送らず、ハッシュ化した値だけを解析基盤へ渡す。
      // eslint-disable-next-line global-require
      const crypto = require('crypto');
      const shasum = crypto.createHash('sha1');
      shasum.update(user.ispCnNo);
      hash = shasum.digest('hex');
    }

    setAnalyticsData(`
     var analyticsData = {
       'myp_ispNum': '${hash}'
     };

    if (window.nmr && typeof window.nmr.mypTrack === 'function') {
      window.nmr.mypTrack();
    }
`);
  }, []);

  return (
    <Head>
      <script src='//assets.adobedtm.com/17361013af29ef6ae83ffd4113ce414f44be89b8/satelliteLib-c22abc4cedf3db040d6b2eb3b1a4615beea06f39.js' />
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: analyticsData,
        }}
      />
    </Head>
  );
};

export default AnalyticsData;
